<template>
  <vl-alert
    icon="warning"
    v-vl-spacer:bottom.small
    v-for="notification in notifications"
    :key="notification.notificationId"
    :title="notification.title"
    :mod-error="isError(notification)"
    :mod-warning="isWarning(notification)"
    :closable="notification.closeable"
    @close="removeNotification(notification.notificationId)"
  >
    <div class="dl-notification__content" v-html="sanitizeNotificationContent(notification.content)"></div>
  </vl-alert>
</template>

<script lang="ts" src="./dl-notifications.ts"></script>

<style lang="scss" scoped src="./dl-notifications.scss"></style>
